import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { pickLang, t } from "../lib/i18n";
import { api } from "../lib/api";
import { Waveform, Lightning, Toolbox, Buildings, VinylRecord, MicrophoneStage, SecurityCamera, VideoCamera, WifiHigh, Headphones, ArrowUpRight } from "@phosphor-icons/react";

const ICONS = { Waveform, Lightning, Toolbox, Buildings, VinylRecord, MicrophoneStage, SecurityCamera, VideoCamera, WifiHigh, Headphones };

export default function Services() {
  const { lang } = useLang();
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20" data-testid="services-page">
      <div className="max-w-3xl">
        <div className="label-tag mb-4 slash">{t("sections.services_eyebrow", lang)}</div>
        <h1 className="display-font text-5xl sm:text-7xl font-black uppercase leading-[0.9] tracking-tighter">
          {lang === "gr" ? <>Από <span className="neon-text">πρώτη γραμμή.</span></> : <>Front of <span className="neon-text">house.</span></>}
        </h1>
        <p className="text-gray-300 mt-6 text-lg">
          {lang === "gr" ? "Πλήρης τεχνική υποστήριξη για κάθε εκδήλωση, χώρο και παραγωγή." : "Full-service pro audio, lighting and installation for any event, venue or production."}
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mt-16">
        {services.map((s, i) => {
          const Ic = ICONS[s.icon] || Waveform;
          return (
            <div key={s.id} className="card-dark p-8" data-testid={`service-${i}`}>
              <div className="flex items-start justify-between">
                <Ic size={42} weight="duotone" className="text-[#ccff00]" />
                <span className="mono-font text-xs tracking-[0.2em] text-gray-500">0{i + 1}</span>
              </div>
              <h3 className="display-font text-2xl font-bold mt-6">{pickLang(s.title, lang)}</h3>
              <p className="text-gray-400 mt-3 leading-relaxed">{pickLang(s.description, lang)}</p>
              <Link to="/contact" className="inline-flex items-center gap-2 mono-font text-xs uppercase tracking-[0.2em] text-[#ccff00] mt-6">
                {t("cta.request_quote", lang)} <ArrowUpRight size={14} />
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
}
